import { Box, InputBase, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useRef, useState } from 'react';
import { useDebounce } from 'use-debounce';

export const SearchField = ({ onChange, debounceMs = 300 }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const [value, setValue] = useState('');
  const [debouncedValue] = useDebounce(value, debounceMs);

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    onChangeRef.current(debouncedValue);
  }, [debouncedValue]);

  function handleChange(e) {
    setValue(e.target.value);
  }

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  return (
    <Box
      className="flex backdrop-blur-lg"
      borderRadius="3px"
      backgroundColor={colors.bgInput}
    >
      <InputBase
        inputRef={async (input) => {
          await delay(1);
          return input && input.focus();
        }}
        placeholder={t('Search')}
        value={value}
        onChange={handleChange}
        className="w-full px-4 py-1"
        sx={{ fontSize: '18px' }}
        endAdornment={<SearchIcon sx={{ color: colors.grey[400] }} />}
      />
    </Box>
  );
};
